"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var validatedViewModel_1 = require("./base/validatedViewModel");
var dateTimeUtils_1 = require("../utils/dateTimeUtils");
var commentUtils_1 = require("../utils/commentUtils");
var richContentUtils_1 = require("../utils/richContentUtils");
var webSocketUtils_1 = require("../../app/utils/webSocketUtils");
var postUtils_1 = require("../../app/utils/postUtils");
var placementsUtils_1 = require("../../app/utils/placementsUtils");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.$feed = $(".feed");
        this.isLoading = ko.observable(false);
        this.moreData = false;
        this.isViewingAccess = ko.observable();
        this.profileId = ko.observable();
        this.offset = ko.observable();
        this.firstPlacement = ko.observable();
        this.secondPlacement = ko.observable();
        this.loadData = function () {
            if (!_this.isLoading()) {
                var $btnToRemove = $(".btn-load-more");
                var $btnMarkAllAsRead = $("#mark_all_as_read");
                _this.isLoading(true);
                var params = {
                    offset: _this.offset(),
                    category: _this.category,
                    lastItemCreationTime: _this.lastItemCreationTime
                };
                if (_this.isViewingAccess && _this.profileId) {
                    params.auId = _this.profileId;
                }
                ajaxUtils_1.AjaxUtils.getHtml("feed/loadMore", params).done(function (result) {
                    if (!result.isSuccessful) {
                        alert(result.messages[0]);
                    }
                    else {
                        _this.moreData = result.data.more;
                        _this.lastItemCreationTime = result.data.creationTime;
                        _this.offset(_this.offset() + _this.pageSize);
                        var $newContent = $(result.data.html);
                        $newContent.appendTo(_this.$feed);
                        $newContent.each(function (index, el) {
                            $(el).addClass("ko-not-initialized");
                        });
                        dateTimeUtils_1.default.displayTime($newContent);
                        richContentUtils_1.default.processHtml($newContent);
                        commentUtils_1.default.init(null);
                        _this.notificationCountReload();
                        setTimeout(function () {
                            $(".feed").find(".ko-not-initialized").each(function (index, el) {
                                ko.applyBindings(_this, el);
                                $(el).removeClass("ko-not-initialized");
                                app.f7.swiper($(el).find(".work-slider")[0], {
                                    slidesPerView: "auto",
                                    speed: 300,
                                    spaceBetween: 8,
                                    slidesPerGroup: 3,
                                    grabCursor: true,
                                    scrollbar: ".swiper-scrollbar"
                                });
                            });
                        });
                    }
                    _this.isLoading(false);
                    $btnToRemove.remove();
                    if ($btnMarkAllAsRead) {
                        $btnMarkAllAsRead.remove();
                    }
                });
            }
        };
        /** Отметить все прочитанными */
        this.markAllAsRead = function () {
            app.f7.alert('Все уведомления отмечены прочитанными', null, function () {
                _this.post("mark-all-as-read");
            });
        };
        /** Переключение в режим непрочитанных уведомлений */
        this.toggleOnlyUnread = function (onlyUnread) {
            app.f7.confirm("\u0422\u0435\u043F\u0435\u0440\u044C \u0432\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u0432\u0438\u0434\u0435\u0442\u044C <b>" + (onlyUnread ? "только непрочитанные" : "все") + "</b> \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F.", 'Смена режима просмотра', function () {
                _this.post("toggle-only-unread");
            });
        };
        this.loadMoreData = function () {
            if (_this.moreData) {
                _this.loadData();
            }
        };
        this.category = options.category;
        this.pageSize = options.pageSize;
        this.moreData = options.more;
        this.lastItemCreationTime = options.lastItemCreationTime;
        this.isViewingAccess = options.isViewingAccess;
        this.profileId = options.profileId;
        this.offset(this.pageSize);
        // Небольшой костыль для кнопок "Подтвердить и стать соавтором". При загрузке страницы они почему-то недоступны
        setTimeout(function () { _this.processing(false); });
        webSocketUtils_1.default.registerServiceWorker();
        $(document).ready(function () {
            commentUtils_1.default.init(null);
            _this.initModalComments();
            richContentUtils_1.default.processHtml(".feed");
            app.f7.swiper(".work-slider", {
                slidesPerView: "auto",
                speed: 300,
                spaceBetween: 8,
                slidesPerGroup: 3,
                grabCursor: true,
                scrollbar: ".swiper-scrollbar"
            });
            postUtils_1.default.startViewStatsCollector();
            setTimeout(function () {
                _this.loadPlacements(options.placementId);
            }, 100);
        });
        this.errorMessages.subscribe(function (err) {
            if (err && err.length) {
                toastr.error(err[0]);
            }
        });
    }
    /** Показывает уведомления группы */
    ViewModel.prototype.showGroupNotifications = function (event, groupId, creationTime, level) {
        if (level === void 0) { level = 1; }
        var $container = level == 1 ? $(event.target).parent().parent() : $(event.target).parent().parent().parent();
        var $containerMore = $(event.target).parent();
        var $feedDetails = $container.parent().find('.feed-details');
        var $spinner = $container.find('.widget-spinner');
        $containerMore.hide();
        $spinner.show();
        var params = {
            groupId: groupId,
            lastNotificationCreationTime: creationTime
        };
        if (this.isViewingAccess && this.profileId) {
            params.auId = this.profileId;
        }
        ajaxUtils_1.AjaxUtils.getHtml("feed/showgroupnotifications", params).done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
                $containerMore.show();
            }
            else {
                $feedDetails.hide();
                $container.html(result.data.html);
                dateTimeUtils_1.default.displayTime($container);
            }
        }).fail(function () {
            $containerMore.show();
        }).always(function () {
            $spinner.hide();
        });
        event.preventDefault();
    };
    /** Отправляет пост запрос */
    ViewModel.prototype.post = function (actionName) {
        var _this = this;
        if (this.processing())
            return;
        this.processing(true);
        ajaxUtils_1.AjaxUtils.post("feed/" + actionName, {})
            .done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
            }
            else {
                location.href = location.href;
            }
        }).always(function () {
            setTimeout(function () {
                _this.processing(false);
            }, 0);
        });
    };
    /** Перезагрузка счетчика непрочитанных уведомлений */
    ViewModel.prototype.notificationCountReload = function () {
        ajaxUtils_1.AjaxUtils.get("notification/check", {})
            .done(function (result) {
            if (!result.isSuccessful) {
                return;
            }
            var notificationCountEl = $("#userNotificationCount");
            if (result.data.userNotificationCount === 0) {
                notificationCountEl.hide();
            }
            else {
                notificationCountEl.show();
            }
            notificationCountEl.html(result.data.userNotificationCount);
        });
    };
    ViewModel.prototype.onSubmitSucess = function (result, formElement) {
        if (result.isSuccessful) {
            if (result.data.refuse) {
                $(formElement).replaceWith("<span class=\"label label-success\">Вы отказались стать соавтором</span>");
            }
            else {
                $(formElement).replaceWith("<span class=\"label label-success\">Вы подтвердили соавторство</span>");
            }
        }
    };
    ViewModel.prototype.initModalComments = function ($container) {
        var _this = this;
        if ($container === void 0) { $container = null; }
        if (!$container) {
            $container = $(".feed");
        }
        $container.on("click touch", "a[data-show-comment]", function (event) {
            var $target = $(event.target);
            var commentHref = $target.attr("data-show-comment"), commentUrl = $target.attr("data-clipboard"), commentId = commentHref.split("_")[0], disableRedirect = $target.attr("data-disable-redirect-btn");
            app.f7.showIndicator();
            ajaxUtils_1.AjaxUtils.get("comment/get", { id: commentId })
                .done(function (result) {
                app.f7.hideIndicator();
                if (result.isSuccessful) {
                    var buttons = [];
                    if (!disableRedirect) {
                        buttons.push({
                            text: "Открыть ветку",
                            onClick: function () { return _this.redirectToPage(commentUrl); }
                        });
                    }
                    ;
                    buttons.push({
                        bold: true,
                        text: "Закрыть"
                    });
                    var $modal = app.f7.modal({
                        text: result.data.html,
                        buttons: buttons
                    });
                    dateTimeUtils_1.default.displayTime($modal);
                    richContentUtils_1.default.processHtml($modal);
                }
                else {
                    alert("Произошла ошибка.");
                }
            });
        });
    };
    /**
     * Загрузка спонсорского контента
     * @param placementId Идентификатор места размещения
     */
    ViewModel.prototype.loadPlacements = function (placementId) {
        var _this = this;
        this.placementId = placementId;
        this.firstPlacement(null);
        this.secondPlacement(null);
        if (!placementId)
            return;
        placementsUtils_1.default.getPlacements("?id=" + placementId, function (items) {
            _this.firstPlacement(items[0]);
            if (items.length > 1) {
                _this.secondPlacement(items[1]);
            }
            setTimeout(function () {
                placementsUtils_1.default.startViewStatsCollector();
            }, 200);
        });
    };
    /** Скрыть спонсорский контент*/
    ViewModel.prototype.hidePlacements = function () {
        this.firstPlacement(null);
        this.secondPlacement(null);
        app.f7.closeModal($("#popoverPlacementInfo")[0]);
        placementsUtils_1.default.hidePlacements(this.placementId);
    };
    return ViewModel;
}(validatedViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=feedIndex.js.map